import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const EatingPatterns = lazyWithPreload(() => import('./EatingPatterns'))
export const LikeChatEatingPatterns = lazyWithPreload(
  () => import('./LikeChatEatingPatterns'),
)
